// extracted by mini-css-extract-plugin
export default {"root":"PropDataActivationModal_root__QJtHb"};